module.exports = __webpack_public_path__ + "static/media/verified.2aec8be9.png";